import { render } from "./CreditCardSimple.vue?vue&type=template&id=b351d36e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CreditCardSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b351d36e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b351d36e', __exports__)) {
    api.reload('b351d36e', __exports__)
  }
  
  module.hot.accept("./CreditCardSimple.vue?vue&type=template&id=b351d36e", () => {
    api.rerender('b351d36e', render)
  })

}


export default __exports__